<div class="explore-all-container">
  <div *ngIf="islandsData.length > 0" class="island-preview-container">
    <div
      *ngFor="let island of islandsData; let i = index"
      class="island-preview"
      [class.island-preview-hidden]="i !== islandIndex"
    >
      <div class="video-slider videoBanner">
        <!-- YouTube Video -->
        <iframe
          *ngIf="island.youtubeurl"
          [src]="island.safeYoutubeUrl"
          frameborder="0"
          style="border: none; margin: 0; padding: 0"
          class="youtube-iframe"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <!-- GIF Image -->
        <img *ngIf="!island.youtubeurl && island.isGif" [src]="island.video" alt="Island Preview" />

        <!-- Regular Video -->
        <video *ngIf="!island.youtubeurl && !island.isGif" #videoPlayer autoplay muted loop>
          <source [src]="island.video" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
  <div class="ishead">
    <div class="explore-head">
      <div class="explore-div">
        <div
          *ngFor="let island of islandsData; let i = index; let isLast = last"
          style="display: flex; flex-direction: column; flex: 1; justify-content: center; align-items: center"
        >
          <div style="flex: 1" class="vertical-line"></div>
          <div
            class="page-number"
            [ngStyle]="{
              width: i === islandIndex ? '25px' : '14px',
              height: i === islandIndex ? '25px' : '14px',
              'background-color': i === islandIndex ? '#fff' : '',
              opacity: i === islandIndex ? '0.5' : ''
            }"
            [class.active]="i === islandIndex"
          >
            <span *ngIf="i === islandIndex" style="color: #978c8c">{{ i + 1 }}</span>
          </div>
          <div style="flex: 1" class="vertical-line"></div>
        </div>
      </div>
      <div *ngIf="islandsData.length > 0" class="idiv">
        <div style="position: relative">
          <div
            *ngFor="let island of islandsData; let i = index"
            style="position: absolute; bottom: 0; left: 0; right: 0"
          >
            <div style="overflow: hidden">
              <h1
                class="island-name"
                [class.island-name-hidden]="i !== islandIndex"
                [style.fontSize.vmin]="dynamicFontSize"
              >
                {{ islandsData[i].name }}
              </h1>
            </div>
            <div
              class="island-description"
              [class.island-description-hidden]="i !== islandIndex"
              [style.fontSize.vmin]="dynamicDescriptionFontSize"
            >
              <span [innerHTML]="islandsData[i].description"></span>
            </div>
          </div>
        </div>
        <div class="button-div">
          <button (click)="exploreNow()" class="btn btn-primary btn-lg routing-btn">
            <span translate>Explore Now</span>
          </button>
          <button style="margin-top: 10px" type="button" (click)="fullScreen()" class="routing-btn routing-btn-outline">
            <span translate>View Full Screen</span>
          </button>
          <div class="nav-btn-container">
            <button type="button" (click)="goToPrevIsland()" style="outline: 0px" class="nav-btn">
              <i class="pi pi-chevron-left"></i>
            </button>
            <button type="button" (click)="goToNextIsland()" style="outline: 0px" class="nav-btn">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="islandsData.length > 0" class="slider-div">
      <app-category-slider
        [currentIndex]="islandIndex"
        [categoryData]="islandsData"
        (onCategorySelection)="onCategorySelection($event)"
      ></app-category-slider>
    </div>
  </div>
</div>
